import React from "react";
import _ from "lodash";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import Checkbox from "components/common/Checkbox";
import { inputClass, tdClass, thClass } from "helpers/StyleClass";
import { FiX } from "react-icons/fi";

class NetworkPlacementModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.selected || [],

      inputValue: "",

      filters: [],
      currentType: "ALL",
    };

    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleRemovePlacement = this.handleRemovePlacement.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentDidMount() {
    const { placements = [] } = this.props;

    const itemsByType = _.groupBy(placements, (item) => {
      return item.props.type;
    });

    const filterTypes = _.map(["ALL", ..._.keys(itemsByType)], (t) => {
      return {
        type: t,
        list: t === "ALL" ? placements : itemsByType[t],
      };
    });

    this.setState({
      filters: filterTypes,
    });
  }

  handleCheckChange(id) {
    const { selected } = this.state;
    const index = _.indexOf(selected, id);
    if (index === -1) {
      this.setState({ selected: [...selected, id] });
    } else {
      const newSelected = _.cloneDeep(selected);
      newSelected.splice(index, 1);
      this.setState({ selected: newSelected });
    }
  }

  handleCheckAll(ids) {
    const { selected } = this.state;
    if (ids.every((id) => selected.includes(id))) {
      // Uncheck all
      this.setState({ selected: _.xor(selected, ids) });
    } else {
      // Check all
      this.setState({ selected: _.union(selected, ids) });
    }
  }

  handleRemovePlacement(id) {
    const { selected } = this.state;
    const index = _.indexOf(selected, id);
    if (index !== -1) {
      const newSelected = _.cloneDeep(selected);
      newSelected.splice(index, 1);
      this.setState({ selected: newSelected });
    }
  }

  handleConfirm() {
    const { selected } = this.state;
    const { handleConfirm } = this.props;

    if (handleConfirm) {
      handleConfirm(selected);
    }
  }

  render() {
    const { selected, inputValue, filters, currentType } = this.state;
    const { handleClose, placements = [] } = this.props;

    const parseFilter = filters.map((f) => {
      return {
        type: f.type,
        list: f.list,
        filter: f.list.filter((item) => {
          return item.id.includes(inputValue);
        }),
      };
    });

    const selectedFilter = parseFilter.find((f) => f.type === currentType);
    const parsePlacements = selectedFilter ? selectedFilter.filter : [];

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        title="Placement View"
        customOverlayStyle={{ zIndex: 100 }}
      >
        <div className="mb-2 flex gap-4" style={{ height: "450px" }}>
          <div className="w-3/5">
            <input
              type="text"
              className={inputClass}
              placeholder="Search by id"
              onChange={(e) => {
                this.setState({ inputValue: e.target.value });
              }}
              value={inputValue}
            ></input>
            <div className="border-b mb-2">
              {parseFilter.length > 0 && (
                <div className="my-2 text-sm font-semibold">
                  {parseFilter.map((t) => {
                    return (
                      <button
                        key={t.type}
                        type="button"
                        className={`rounded mr-1 px-2 py-1 font-semibold ${
                          currentType === t.type
                            ? "bg-indigo-100 text-indigo-800"
                            : "text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
                        }`}
                        onClick={() => {
                          this.setState({
                            currentType: t.type,
                          });
                        }}
                      >
                        {t.type}{" "}
                        {inputValue === ""
                          ? `(${t.list.length})`
                          : `(${t.filter.length}/${t.list.length})`}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
            <div
              className="mb-2 overflow-y-auto"
              style={{ height: "calc(100% - 8rem)" }}
            >
              {placements.length === 0 ? (
                <div>No resource mapping</div>
              ) : (
                <div className="h-full w-full">
                  <MappingTable
                    items={parsePlacements}
                    selected={selected}
                    handleCheck={(id) => {
                      this.handleCheckChange(id);
                    }}
                    handleCheckAll={(ids) => {
                      this.handleCheckAll(ids);
                    }}
                  ></MappingTable>
                </div>
              )}
            </div>
          </div>
          <div className="rounded mb-2 h-full w-2/5 overflow-y-auto bg-gray-200 p-2">
            <div className="flex flex-wrap gap-1">
              {selected.map((id) => {
                const item = placements.find((p) => p.id === id);
                if (!item) {
                  return (
                    <div
                      key={id}
                      className="border rounded border-gray-400 bg-red-200 px-1 text-sm"
                    >
                      <div className="flex items-center gap-2">
                        {id} UNKNOWN
                        <span
                          className="ml-1 cursor-pointer hover:text-blue-700"
                          onClick={() => this.handleRemovePlacement(id)}
                        >
                          <FiX></FiX>
                        </span>
                      </div>
                    </div>
                  );
                }
                return (
                  <div
                    key={id}
                    className="border rounded border-gray-400 bg-blue-200 px-1 text-sm"
                  >
                    <div className="flex items-center gap-2">
                      {id} {item.props.type}
                      <span
                        className="ml-1 cursor-pointer hover:text-blue-700"
                        onClick={() => this.handleRemovePlacement(id)}
                      >
                        <FiX></FiX>
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <ModalFooter
          confirmText={`Select placement (${selected.length})`}
          onConfirm={this.handleConfirm}
          onCancel={handleClose}
        ></ModalFooter>
      </ModalWrapper>
    );
  }
}

function MappingTable({ items, selected, handleCheck, handleCheckAll }) {
  function propsElement(item) {
    let element = "";
    switch (item.props.type) {
      case "UPR_SEGMENT_OPT_X":
      case "UPR_SEGMENT_OPT": {
        element = (
          <div>
            <div>Segment ID: {item.props.segmentId}</div>
            <div>Price Setting ID: {item.props.priceSettingId}</div>
            <div>Price Index: {item.props.priceIndex}</div>
          </div>
        );
        break;
      }

      default: {
        let newProps = _.cloneDeep(item.props);
        newProps = _.omit(newProps, ["type"]);
        element = (
          <div className="text-gray-800">
            {_.keys(newProps).map((key) => {
              const value = newProps[key];
              return (
                <div key={key}>
                  {key}:{" "}
                  <span className="font-semibold">
                    {typeof value === "object" ? JSON.stringify(value) : value}
                  </span>
                </div>
              );
            })}
          </div>
        );
      }
    }

    return element;
  }

  return (
    <table className="border shadow table w-full text-sm">
      <thead className="border-b bg-gray-200 text-xs text-blue-800">
        <tr>
          <th className={thClass + " w-8"}>
            {items.length > 0 && (
              <Checkbox
                isChecked={items.every((item) => selected.includes(item.id))}
                onChange={() => handleCheckAll(items.map((item) => item.id))}
              ></Checkbox>
            )}
          </th>
          <th className={thClass}>ID</th>
          <th className={thClass}>Type</th>
          <th className={thClass}>Props</th>
        </tr>
      </thead>
      <tbody className="bg-white  text-gray-900">
        {items.map((item) => {
          return (
            <tr
              key={item.id}
              className="cursor-pointer hover:bg-gray-100"
              onClick={() => handleCheck(item.id)}
            >
              <td className={tdClass}>
                <Checkbox
                  isChecked={selected.includes(item.id)}
                  onChange={() => handleCheck(item.id)}
                ></Checkbox>
              </td>
              <td className={tdClass}>{item.id}</td>
              <td className={tdClass}>{item.props.type}</td>
              <td className={tdClass}>{propsElement(item)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default NetworkPlacementModal;
